export enum LoadSuggestedTricksStatus {
    ZERO = "0",
    ONE = "1",
}